import modal from './modal.ts'

export default function () {
	modal()
}
